import './style.scss'
import { Button, Input, Modal } from 'antd'
import { FC, memo, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import * as homeApi from '@/api/home'

interface IProps {
  open: boolean
  onSuccess?: () => void
  onCancel?: () => void
}

const QaModal: FC<IProps> = (props) => {
  const { t: translate } = useTranslation(['qa_modal'])
  const { open, onSuccess, onCancel } = props
  const [qaStep, setQaStep] = useState(0)
  const [questions, setQuestions] = useState<any[]>([])
  const [answers, setAnswers] = useState<any[]>([])
  const [answerInput, setAnswerInput] = useState('')
  const [answerInputShow, setAnswerInputShow] = useState(false)
  const [closeConfirm, setCloseConfirm] = useState(false)
  const [successModalOpen, setSuccessModalOpen] = useState(false)

  useEffect(() => {
    if (open) {
      getQuestion()
    }
    setCloseConfirm(false)
    setQaStep(0)
    setAnswers([])
    setAnswerInput('')
    setAnswerInputShow(false)
  }, [open])

  const getQuestion = async () => {
    const res = await homeApi.getQuestions()
    setQuestions(res.questions || [])
  }

  const submitQa = async () => {
    await homeApi.submitQa({
      answers: answers.map((a) => {
        return a.answerInput
          ? {
              id: a.id,
              answer: a.answerInput || a.answer
            }
          : a
      })
    })
    onCancel?.()
    onSuccess?.()
    setSuccessModalOpen(true)
  }

  return (
    <>
      <Modal
        width={510}
        title={null}
        onCancel={() => {
          closeConfirm ? onCancel?.() : setCloseConfirm(true)
        }}
        open={!!open}
        footer={null}
        className="commom-modal qa-modal"
      >
        <div className="qa-modal-body">
          <div className="header">{translate('qa_modal.reward_points')}</div>
          <div className="main">
            {!closeConfirm ? (
              <>
                <div className="desc">
                  <div className="welcome">{translate('qa_modal.greeting')}</div>
                  <div className="text">{translate('qa_modal.description')}</div>
                </div>
                <div className="question">{questions[qaStep]?.title}</div>
                <div className="answer">
                  {questions[qaStep]?.templates?.map((t: any) => (
                    <div
                      key={t}
                      className={`answer-box ${answers[qaStep]?.answer === t ? 'actived' : ''}`}
                      onClick={() => {
                        const id = questions[qaStep].id
                        const r = {
                          id,
                          answer: t
                        }
                        setAnswerInputShow(t === translate('qa_modal.other_option'))
                        setAnswerInput('')
                        if (answers?.length) {
                          setAnswers([...answers.filter((a) => a.id !== id), r])
                        } else {
                          setAnswers([r])
                        }
                      }}
                    >
                      {t}
                    </div>
                  ))}
                </div>

                {answerInputShow && (
                  <div className="other">
                    <div className="text">{translate('qa_modal.other_label')}</div>
                    <Input
                      className="answer-input"
                      maxLength={100}
                      placeholder={translate('qa_modal.input_placeholder')}
                      value={answerInput}
                      onInput={(e: any) => {
                        const value = e.target.value
                        const id = questions[qaStep].id
                        setAnswerInput(value)
                        setAnswers(
                          answers.map((a) => {
                            return a.id === id
                              ? {
                                  ...a,
                                  answerInput: value
                                }
                              : a
                          })
                        )
                      }}
                    />
                  </div>
                )}

                <div className="bottom">
                  {qaStep + 1 >= questions.length ? (
                    <Button
                      className={`btn ${
                        (answers[qaStep]?.answer && answers[qaStep]?.answer !== translate('qa_modal.other_option')) ||
                        (answers[qaStep]?.answer === translate('qa_modal.other_option') && answers[qaStep]?.answerInput)
                          ? ''
                          : 'unable'
                      }`}
                      type="primary"
                      onClick={submitQa}
                    >
                      {translate('qa_modal.submit_questionnaire')}
                    </Button>
                  ) : (
                    <Button
                      className={`btn ${
                        (answers[qaStep]?.answer && answers[qaStep]?.answer !== translate('qa_modal.other_option')) ||
                        (answers[qaStep]?.answer === translate('qa_modal.other_option') && answers[qaStep]?.answerInput)
                          ? ''
                          : 'unable'
                      }`}
                      type="primary"
                      onClick={() => {
                        setQaStep(qaStep + 1)
                        setAnswerInput('')
                        setAnswerInputShow(false)
                      }}
                    >
                      {translate('qa_modal.next_button')}
                    </Button>
                  )}
                </div>
              </>
            ) : (
              <div className="close-confirm">
                <div className="confirm-title">{translate('qa_modal.confirm_exit_title')}</div>
                <div className="confirm-desc">
                  {translate('qa_modal.confirm_exit_description', { count: questions.length })}
                </div>
                <div className="btns">
                  <Button type="default" onClick={onCancel}>
                    {translate('qa_modal.exit_button')}
                  </Button>
                  <Button type="primary" onClick={() => setCloseConfirm(false)}>
                    {translate('qa_modal.continue_button')}
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </Modal>
      <Modal
        width={450}
        title={null}
        onCancel={() => setSuccessModalOpen(false)}
        open={successModalOpen}
        footer={null}
        className="commom-modal qa-succes-modal"
        closeIcon={null}
      >
        <div className="qa-succes-modal-body">
          <div className="title gradient">{translate('qa_modal.success_title')}</div>
          <div className="desc">{translate('qa_modal.success_description')}</div>
          <Button className="primary" type="primary" onClick={() => setSuccessModalOpen(false)}>
            {translate('qa_modal.start_experience')}
          </Button>
        </div>
      </Modal>
    </>
  )
}

export default memo(QaModal)
